(() => {
  const initPremiumHeader = (scope = document) => {
    const header = scope.querySelector?.('[data-kt15-header]') || document.querySelector('[data-kt15-header]');
    if (!header || header.dataset.kt15Ready === 'true') return;
    header.dataset.kt15Ready = 'true';

    const triggers = [...header.querySelectorAll('[data-kt15-mega-trigger]')];
    const panels = [...header.querySelectorAll('[data-kt15-mega-panel]')];
    let closeTimer = null;
    let activeKey = null;

    const cancelClose = () => {
      if (closeTimer) window.clearTimeout(closeTimer);
      closeTimer = null;
    };

    const open = (key) => {
      cancelClose();
      activeKey = key;
      header.classList.add('is-mega-open');
      triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', String(trigger.dataset.kt15MegaTrigger === key)));
      panels.forEach((panel) => {
        const match = panel.dataset.kt15MegaPanel === key;
        panel.classList.toggle('is-open', match);
        panel.setAttribute('aria-hidden', String(!match));
      });
    };

    const close = (delay = 0) => {
      cancelClose();
      const run = () => {
        activeKey = null;
        header.classList.remove('is-mega-open');
        triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
        panels.forEach((panel) => {
          panel.classList.remove('is-open');
          panel.setAttribute('aria-hidden', 'true');
        });
      };
      if (delay) closeTimer = window.setTimeout(run, delay);
      else run();
    };

    triggers.forEach((trigger) => {
      const key = trigger.dataset.kt15MegaTrigger;
      const navItem = trigger.closest('.kt15-nav-item');
      navItem?.addEventListener('mouseenter', () => open(key));
      navItem?.addEventListener('mouseleave', () => close(110));
      trigger.addEventListener('focus', () => open(key));
      trigger.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          open(key);
          const firstLink = header.querySelector(`[data-kt15-mega-panel="${key}"] a`);
          firstLink?.focus();
        }
        if (event.key === 'Escape') {
          close();
          trigger.focus();
        }
      });
    });

    panels.forEach((panel) => {
      panel.addEventListener('mouseenter', cancelClose);
      panel.addEventListener('mouseleave', () => close(120));
      panel.addEventListener('focusin', () => open(panel.dataset.kt15MegaPanel));
      panel.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          const key = panel.dataset.kt15MegaPanel;
          close();
          header.querySelector(`[data-kt15-mega-trigger="${key}"]`)?.focus();
        }
      });
    });

    document.addEventListener('pointerdown', (event) => {
      if (activeKey && !header.contains(event.target)) close();
    });

    window.addEventListener('scroll', () => {
      if (activeKey) close();
    }, { passive: true });

    const mobileButton = header.querySelector('[data-kt6-menu-toggle]');
    const mobileNav = header.querySelector('[data-kt6-mobile-nav]');
    if (mobileButton && mobileNav) {
      const syncMobile = () => {
        const isOpen = mobileButton.getAttribute('aria-expanded') === 'true';
        header.classList.toggle('is-mobile-open', isOpen);
      };
      mobileButton.addEventListener('click', () => requestAnimationFrame(syncMobile));
    }
  };

  const init = () => initPremiumHeader(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => initPremiumHeader(event.target));
})();
